import { combineReducers } from "@reduxjs/toolkit";
import customerPortalBookingReducer from "../modules/customer-portal/store/customerPortalBookingSlice";

const reducer = combineReducers({
  customerPortalBooking: customerPortalBookingReducer,
});

export default reducer;
